import { handleActions } from 'redux-actions';
import moment from 'moment';
import { cloneDeep } from 'lodash';

import * as actionDefinitions from './actionDefinitions';
import * as userSettingsTypes from '../UserSettings/types';

import { excludeIntacctId, includeIntacctId, sortObjectsByNameAsc } from '../../helpers/utils';

import { ClientsResponse, ClientsStore } from '../../types/redux/stores/clients.types';
import { SimpleAction } from '../../types/redux/actions';

const initialState: ClientsStore = {
  data: [],
  error: null,
  initialLoad: false,
  lastSync: null,
  loading: false,
  saving: false,
};

const getClientsRequest = (state: ClientsStore): ClientsStore => {
  return {
    ...state,
    error: null,
    loading: true,
  };
};
const getClientsRequestFailure = (state: ClientsStore, action: SimpleAction): ClientsStore => {
  return {
    ...state,
    data: [],
    error: action.error,
    loading: false,
  };
};
const getClientsRequestSuccess = (state: ClientsStore, action: SimpleAction<ClientsResponse>): ClientsStore => {
  let data = action.payload?.res || [];
  if (action.payload?.showIntacctId) {
    data.map((d) => includeIntacctId(d));
  }
  data.sort(sortObjectsByNameAsc);
  return {
    ...state,
    data,
    error: null,
    initialLoad: true,
    lastSync: moment().toString(),
    loading: false,
  };
};

const getClientsStopLoading = (state: ClientsStore): ClientsStore => {
  return {
    ...state,
    loading: false,
  };
};

const showIntacctId = (state: ClientsStore): ClientsStore => {
  const data = cloneDeep(state.data);
  data.map((d) => includeIntacctId(d));
  data.sort(sortObjectsByNameAsc);
  return {
    ...state,
    data,
  };
};
const hideIntacctId = (state: ClientsStore): ClientsStore => {
  const data = cloneDeep(state.data);
  data.map((d) => excludeIntacctId(d));
  data.sort(sortObjectsByNameAsc);
  return {
    ...state,
    data,
  };
};

export default handleActions(
  {
    [actionDefinitions.GET_CLIENTS_REQUEST]: getClientsRequest,
    [actionDefinitions.GET_CLIENTS_REQUEST_FAILURE]: getClientsRequestFailure,
    [actionDefinitions.GET_CLIENTS_REQUEST_SUCCESS]: getClientsRequestSuccess,
    [actionDefinitions.GET_CLIENTS_STOP_LOADING]: getClientsStopLoading,
    [userSettingsTypes.SHOW_INTACCT_ID]: showIntacctId,
    [userSettingsTypes.HIDE_INTACCT_ID]: hideIntacctId,
  },
  initialState
);
